/**
 * Roll a 6-sided die
 * @returns {number} Random number between 1 and 6
 */
export const rollD6 = () => Math.floor(Math.random() * 6) + 1;

/**
 * Roll a 20-sided die
 * @returns {number} Random number between 1 and 20
 */
export const rollD20 = () => Math.floor(Math.random() * 20) + 1;

/**
 * Roll two 6-sided dice and sum the results
 * @returns {number} Sum of two d6 rolls (2-12)
 */
export const roll2D6 = () => rollD6() + rollD6();
